import React from 'react';
import { createRoot } from 'react-dom/client';
import { LoginService } from '@ey/mfe-ui-core';
import { MsalProvider } from '@azure/msal-react';
import { Router } from './helpers/Routing';
import { Provider } from 'react-redux';
import store from './store/store';
import { LogLevel } from "@azure/msal-browser";

const { REACT_APP_CLIENT_ID, REACT_APP_TENANT_ID, REACT_APP_AUTHORITY_URL } = process.env;

const msalConfig = {
  clientId: REACT_APP_CLIENT_ID!,
  tenantId: REACT_APP_TENANT_ID!,
  authorityUrl: REACT_APP_AUTHORITY_URL!,
  redirectUrl: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  storeAuthStateInCookie: false,
  loggerOptions: {
    loggerCallback: (level, message, containsPii) => {
      if (containsPii) {
        return;
      }
      switch (level) {
        case LogLevel.Error:
          console.error(message);
          return;
        case LogLevel.Info:
          console.info(message);
          return;
        case LogLevel.Verbose:
          console.debug(message);
          return;
        case LogLevel.Warning:
          console.warn(message);
          return;
      }
    },
    piiLoggingEnabled: false,
    logLevel: LogLevel.Info,
  }
};

const loginService = new LoginService();
const msalInstance = loginService.generateMSALInstance(msalConfig);

const renderer = () => {
  const root = createRoot(document.getElementById('app')!);
  msalInstance.initialize().then(() => {
    root.render(
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <Router />
        </Provider>
      </MsalProvider>
    );
  });
};

export { renderer as default };
